module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn-like-action like-button",
    class: _vm.likeClass,
    attrs: {
      "type": "button",
      "disabled": _vm.isDisable,
      "title": _vm.likeTitle
    },
    on: {
      "click": _vm.addLike
    }
  }, [_c('i', {
    staticClass: "ico ico-favor"
  }), _vm._v(" "), _c('span', {
    staticClass: "alt-text"
  }, [_vm._v(_vm._s(_vm.altText))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.count))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f412b990"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/job/LikeBtn.vue
// module id = 1535
// module chunks = 6